module.exports = __webpack_public_path__ + "static/media/Missandei 1.fb98cb29.jpg";